import { Cart } from "../../components/Cart/Cart";

export const CartPage = () => {
  return (
    <div>
      <h1>Cart</h1>
      <Cart />
    </div>
  );
};
